import {
  trigger,
  style,
  animate,
  transition
} from '@angular/animations';

/**
 * This is the animation for mobile view menu
 */
export const navigationAnimation = trigger(
  'navigationAnimation', [
    transition(':enter', [
      style({ transform: 'translate3d(-100%,0,0)' }),
      animate('200ms ease-in-out', style({ transform: 'translate3d(0,0,0)' }))
    ]),
    transition(':leave', [
      style({ transform: 'translate3d(0,0,0)' }),
      animate('200ms ease-in-out', style({ transform: 'translate3d(-100%,0,0)' }))
    ])
  ]
);
